<template lang="html">
  <i :class="css" />
</template>

<script>
export default {
  name: 'AtlasIcon',
  props: {
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    css () {
      return 'atlas-icon-' + this.name
    }
  }
}
</script>

<style lang="scss">
@import './fontello/css/atlas-icons.css';
.media-icon {
  font-size: 20px;
}
</style>
